import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { formControlElement, formLabelElement } from 'src/app/animations/animations';
import { MaxWordLimit } from 'src/app/constants/constants';
@Component({
    selector: 'app-others-proposal-overview',
    templateUrl: './others-proposal-overview.component.html',
    styleUrl: './others-proposal-overview.component.less',
    animations: [formControlElement, formLabelElement],
    standalone: false
})
export class OthersProposalOverviewComponent {
  @Input() OthersProposalOverviewForm!: UntypedFormGroup;
  wordLimit = MaxWordLimit;
}
